import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_OBSERVATION,
  CREATE_OBSERVATION_COMMENT,
  DELETE_MANY_OBSERVATION,
  DELETE_OBSERVATION_COMMENT,
  DELETE_SINGLE_OBSERVATION,
  EDIT_OBSERVATION,
  FETCH_OBSERVATIONS,
  GET_OBSERVATION_COMMENTS,
  GET_SINGLE_OBSERVATION,
  SAVE_OBSERVATION,
} from 'setup/redux/Actions/Observation/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(SAVE_OBSERVATION, fetchData)
  yield takeEvery(FETCH_OBSERVATIONS, fetchData)
  yield takeEvery(CREATE_OBSERVATION, fetchData)
  yield takeEvery(GET_SINGLE_OBSERVATION, fetchData)
  yield takeEvery(DELETE_MANY_OBSERVATION, fetchData)
  yield takeEvery(GET_OBSERVATION_COMMENTS, fetchData)
  yield takeEvery(DELETE_SINGLE_OBSERVATION, fetchData)
  yield takeEvery(CREATE_OBSERVATION_COMMENT, fetchData)
  yield takeEvery(DELETE_OBSERVATION_COMMENT, fetchData)
  yield takeEvery(EDIT_OBSERVATION, fetchData)
}

export default dataSaga
